// extracted by mini-css-extract-plugin
module.exports = {"CommentListPlaceholder":"hj_a bag_je","CommentListPlaceholder--Legacy":"hj_b bag_ol bag_tn"};